import { render, staticRenderFns } from "./VideoChoiceWidget.vue?vue&type=template&id=0fad5896&scoped=true&xmlns%3Av-clipboard=http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml&"
import script from "./VideoChoiceWidget.vue?vue&type=script&lang=js&"
export * from "./VideoChoiceWidget.vue?vue&type=script&lang=js&"
import style0 from "./VideoChoiceWidget.vue?vue&type=style&index=0&id=0fad5896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad5896",
  null
  
)

export default component.exports